/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Archive_ConfirmInputs */

const cs_property_archive_confirm = /** @type {(inputs: Property_Archive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivovat tuto nemovitost? Skryje se na webu.`)
};

const en_property_archive_confirm = /** @type {(inputs: Property_Archive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive this property? It will be hidden on the website.`)
};

/**
* | output |
* | --- |
* | "Archive this property? It will be hidden on the website." |
*
* @param {Property_Archive_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_archive_confirm = /** @type {((inputs?: Property_Archive_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Archive_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_archive_confirm(inputs)
	return cs_property_archive_confirm(inputs)
});